export enum ReplicationModel {
    Sync = 1,
    Async = 2
}

export enum PairCreationMode {
    Auto = 1,
    Manu = 2
}

export enum RemoteNameRule {
    /** omtask自动生成 */
    SystemCustom = 0,
    /** 与本端一致 */
    Local = 1,
    /** 自定义 */
    Custom = 2
}

export enum SyncMethod {
    // 手动
    Manu = 1,
    // 同步开始后定时等待
    SyncBegin = 2,
    // 同步完成后定时等待
    SyncEnd = 3,
    // 指定时间策略
    // eslint-disable-next-line @typescript-eslint/no-shadow
    TimeStrategy = 4
}

export enum Speed {
    Custom = 'custom',
    Low = 1,
    Medium = 2,
    High = 3,
    Highest = 4
}

export enum TimeStrategy {
    Week = 1,
    Day = 2,
    Hour = 3
}

export enum IntervalUnit {
    Minute = 'min',
    Second = 'sec'
}

export enum IntervalRangeMinute {
    Min = 1,
    Max = 1440
}

export enum IntervalRangeSecond {
    Min = 3,
    Max = 59
}

// 恢复策略
export enum RecoveryPolicy {
    Auto = 1,
    Manu = 2
}

export enum InitialSync {
    Auto = 1,
    Manu = 2
}

export enum BandwidthRange {
    Min = 1,
    Max = 1024
}

export enum RemTimeoutPeriodRange {
    Min = 10,
    Max = 30,
    Invalid = 255
}

export enum Step {
    Specify = 0,
    ConfigureParam = 1,
    Confirm = 2
}

export enum EplArrayType {
    replication = 1,
    heterogeneity = 2,
    unknown = 3,
    cloudReplication = 4
}

export enum SynchronizeType {
    manual = 1,
    timedWaitWhenBegin = 2,
    timedWaitWhenEnd = 3
}

export enum SyncSnapPolicyType {
    // 不同步用户快照
    NOT_SYNC_SNAP = '0',
    // 从端与主端保持一致
    SAME_AS_SOURCE = '1',
    // 从端保留指定数量用户快照
    USER_SNAP_RETENTION_NUM = '2'
}

export enum BackupCopyPolicyType {
    // 从端不保留副本快照
    NO_RETENTION = '0',
    // 从端保留指定数量副本快照
    COPY_SNAP_RETENTION_NUM = '1'
}

/**
 * 0:相同系列; 1:兼容系列
 */
export enum SeriesType {
    IdenticalSeries = '0',
    CompatibleSeries = '1'
}

export enum DeviceVersion {
    newV6Version = 'newV6Version',
    oldV6Version = 'oldV6Version',
    compatibleDevice = 'compatibleDevice'
}

export enum DeviceVersionErr {
    singleEmpty = 'singleEmpty'
}

export interface CheckRemoteNameParams {
    protectGroupName?: string;
    lunIDs?: string[];
    lunGroupId?: number;
    protectGroupId?: number;
    fsIDs?: string[];
    remoteStorageId?: number;
    remoteDevName?: string;
    remoteNameRule?: number;
    nameSuffix?: string;
    namePrefix?: string;
    pairType?: PairTypeE;
}

export enum PairTypeE {
    replication = 1,
    metro = 2
}

export enum SupBatchOperate {
    notSupBatch = '0',
    supBatch = '1'
}
